import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import EnvironmentModel from 'cio/models/environment';

export default class ExtApiKeyModel extends Model {
  @attr('string') name!: string;
  @attr('string') apiKey!: string;
  @attr('number') createdAt!: number;
  @attr('number') lastUsedAt!: number;
  @attr('string') hint!: string;
  @attr('number') updatedAt!: number;

  @belongsTo('environment', { async: false, inverse: null }) environment!: EnvironmentModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'ext-api-key': ExtApiKeyModel;
  }
}
